export enum WARRANTY_STORAGE_KEYS {
  TimePeriodPreference = "warranty-time-period-preference",
  LocationPreference = "warranty-location-preference",
  DealerPreference = "warranty-dealer-preference",
  PinStatusPreference = "warranty-pin-status-preference",
  ClaimedPreference = "warranty-claimed-preference",
  DeletedPreference = "warranty-deleted-preference",
  MechanicFixedPreference = " warranty-mechanic-fixed-preference",
  BrandsPreference = "warranty-brands-preference",
  AppointmentStatusIdentifiersPreference = "warranty-appointment-status-identifiers-preference-v2",
  PinTypePreference = "warranty-pin-type-preference",
  RegVinPreference = "warranty-reg-vin-preference",
  WarrantyTypePreference = "warranty-warranty-type-preference",
  ClaimSortPreference = "warranty-claim-sort-preference",
  QuestionStatusPreference = "warranty-question-status-preference",
  OrderByPreference = "warranty-order-by-preference",
  PinDateFromPreference = "warranty-date-from-preference",
  PinDateToPreference = "warranty-date-to-preference",
  AppointmentDateFromPreference = "warranty-appointment-date-from-preference",
  AppointmentDateToPreference = "warranty-appointment-date-to-preference",
  AppointmentTimePeriodPreference = "warranty-appointment-time-period-preference",
  PageSizePreference = "warranty-page-size-preference",
  LocationOrderByPreference = "warranty-page-location-order-by-preference"
}
